"use client"

import { Building2 } from "lucide-react"
import { useState } from "react"

import { cn } from "@/lib/utils"

// Company-header icon: the business's own site favicon inside a rounded chip,
// falling back to a generic building glyph when there is no website or the
// favicon fails to load.
export function SiteFavicon({
  website,
  domain,
  className,
}: {
  website?: string | null
  domain?: string | null
  className?: string
}) {
  const [failed, setFailed] = useState(false)
  const host = faviconHost(website, domain)
  return (
    <span
      className={cn(
        "border-border flex size-6 shrink-0 items-center justify-center overflow-hidden rounded-md border",
        className,
      )}
    >
      {host && !failed ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={`https://www.google.com/s2/favicons?domain=${host}&sz=64`}
          alt=""
          width={16}
          height={16}
          loading="lazy"
          decoding="async"
          className="size-4"
          onError={() => setFailed(true)}
        />
      ) : (
        <Building2 className="text-muted-foreground size-3.5" />
      )}
    </span>
  )
}

function faviconHost(website?: string | null, domain?: string | null): string {
  if (domain && domain.trim()) return domain.trim()
  const raw = (website || "").trim()
  if (!raw) return ""
  try {
    return new URL(raw).hostname
  } catch {
    return raw.replace(/^https?:\/\//, "").split("/")[0]
  }
}
